let snackbarRef;

export const setSnackbarRef = (ref) => {
  snackbarRef = ref;
};

export const toastMessage = (message, variant = 'default') => {
  snackbarRef && snackbarRef.enqueueSnackbar(message, { variant, anchorOrigin: { horizontal: 'right', vertical: 'top' } });
};

let passwordExpiredToastShown = false;

export const resetPasswordExpiredToast = () => {
  passwordExpiredToastShown = false;
};

export const toastPasswordExpiredOnce = (message) => {
  if (!passwordExpiredToastShown) {
    passwordExpiredToastShown = true;
    toastMessage(message, 'error');
  }
};
